import type { Landmark } from "../utils/types.ts";

export const WRIST = 0;
export const THUMB_CMC = 1;
export const THUMB_MCP = 2;
export const THUMB_IP = 3;
export const THUMB_TIP = 4;
export const INDEX_MCP = 5;
export const INDEX_PIP = 6;
export const INDEX_DIP = 7;
export const INDEX_TIP = 8;
export const MIDDLE_MCP = 9;
export const MIDDLE_PIP = 10;
export const MIDDLE_DIP = 11;
export const MIDDLE_TIP = 12;
export const RING_MCP = 13;
export const RING_PIP = 14;
export const RING_DIP = 15;
export const RING_TIP = 16;
export const PINKY_MCP = 17;
export const PINKY_PIP = 18;
export const PINKY_DIP = 19;
export const PINKY_TIP = 20;

export const HAND_CONNECTIONS: Array<[number, number]> = [
  [0, 1],
  [1, 2],
  [2, 3],
  [3, 4],
  [0, 5],
  [5, 6],
  [6, 7],
  [7, 8],
  [0, 9],
  [9, 10],
  [10, 11],
  [11, 12],
  [0, 13],
  [13, 14],
  [14, 15],
  [15, 16],
  [0, 17],
  [17, 18],
  [18, 19],
  [19, 20],
  [5, 9],
  [9, 13],
  [13, 17],
];

export const FINGERS = [
  { name: "index", mcp: INDEX_MCP, pip: INDEX_PIP, tip: INDEX_TIP },
  { name: "middle", mcp: MIDDLE_MCP, pip: MIDDLE_PIP, tip: MIDDLE_TIP },
  { name: "ring", mcp: RING_MCP, pip: RING_PIP, tip: RING_TIP },
  { name: "pinky", mcp: PINKY_MCP, pip: PINKY_PIP, tip: PINKY_TIP },
] as const;

export function assertHand(landmarks: Landmark[]): Landmark[] {
  if (landmarks.length < 21) {
    throw new Error("Hand landmark set must contain 21 points.");
  }
  return landmarks;
}

export function centroid(landmarks: Landmark[]): Landmark {
  let x = 0;
  let y = 0;
  let z = 0;
  for (const point of landmarks) {
    x += point.x;
    y += point.y;
    z += point.z;
  }
  const n = landmarks.length || 1;
  return { x: x / n, y: y / n, z: z / n };
}
